import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import { ImWhatsapp } from 'react-icons/im';
import TimeSlotButton from './TimeSlotButton';

/** ISO date string (YYYY-MM-DD) → M/D/YYYY e.g. 5/11/2026 */
const formatIsoDateUs = (isoDate) => {
  if (!isoDate || typeof isoDate !== 'string') return '';
  const parts = isoDate.split('-');
  if (parts.length !== 3) return isoDate;
  const [y, m, d] = parts;
  return `${Number(m)}/${Number(d)}/${y}`;
};

const TimeSlotGrid = ({
  openingHours,
  isLoading,
  fullyBooked,
  selectedTime,
  onSelectTime,
  currentColor,
  guest,
  IS_FORNO,
  selectedFloorPlanName,
  date,
  events,
  IS_SHIRO,
}) => {
  const hasNoSlots =
    !openingHours ||
    openingHours.length === 0 ||
    (openingHours[0]?.length === 0 && openingHours[1]?.length === 0);

  const showError = date === '2026-03-29' && IS_SHIRO;

  const dateLabel = formatIsoDateUs(date);

  // console.log(date === '2026-02-14', 'DATE CHECK');

  return (
    <Box
      sx={{
        mt: 1.5,
        display: 'grid',
        gridTemplateColumns: {
          xs: 'repeat(2, minmax(0, 1fr))',
          sm: 'repeat(3, minmax(0, 1fr))',
          md: 'repeat(5, minmax(0, 1fr))',
        },
        gap: 1,
      }}
    >
      {!showError && (
        <>
          {isLoading && (
            <Box
              align="center"
              sx={{ gridColumn: '1 / -1', width: '100%', py: 1 }}
            >
              <LinearProgress sx={{ width: '50%' }} />
              <Typography
                sx={{
                  color: 'primary.main',
                  fontSize: '10px',
                }}
              >
                Checking for Available Time...
              </Typography>
            </Box>
          )}
        </>
      )}
      {!showError && (
        <>
          {hasNoSlots ? (
            <>
              {!isLoading && (
                <Box sx={{ p: 1, width: '100%', mt: 1, gridColumn: '1 / -1' }}>
                  {guest > 9 && IS_FORNO ? (
                    <>
                      <Typography
                        sx={{
                          textAlign: 'center',
                          fontWeight: 300,
                          fontSize: '12px',
                        }}
                      >
                        Please contact the restaurant to confirm your
                        reservation
                      </Typography>
                      <a
                        href="https://wa.me/2349161178000"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            columnGap: 2,
                            alignItems: 'center',
                            mt: 1,
                          }}
                        >
                          <Typography>Chat us here</Typography>
                          <ImWhatsapp />
                        </Box>
                      </a>
                    </>
                  ) : (
                    <Typography
                      sx={{
                        textAlign: 'center',
                        fontWeight: 300,
                        fontSize: '12px',
                      }}
                    >
                      <Typography
                        sx={{
                          textAlign: 'center',
                          fontWeight: 600,
                          color: currentColor.primary,
                        }}
                      >
                        {selectedFloorPlanName
                          ? `${selectedFloorPlanName} is not opened for ${dateLabel}`
                          : `This seating area is not opened for ${dateLabel}`}
                      </Typography>
                      You can try selecting another date or guest size
                    </Typography>
                  )}
                </Box>
              )}
            </>
          ) : (
            <>
              {fullyBooked ? (
                <>
                  {openingHours[0]?.map((time, index) => (
                    <TimeSlotButton
                      key={index}
                      time={time}
                      selectedTime={selectedTime}
                      onSelectTime={onSelectTime}
                      currentColor={currentColor}
                      isFullyBooked={true}
                    />
                  ))}
                  {openingHours[1]?.map((time, index) => (
                    <TimeSlotButton
                      key={index}
                      time={time}
                      selectedTime={selectedTime}
                      onSelectTime={onSelectTime}
                      currentColor={currentColor}
                      isFullyBooked={true}
                    />
                  ))}
                </>
              ) : (
                <>
                  {openingHours[0]?.map((time, index) => (
                    <TimeSlotButton
                      key={index}
                      time={time}
                      selectedTime={selectedTime}
                      onSelectTime={onSelectTime}
                      currentColor={currentColor}
                      isAvailable={time?.IsAvailable}
                    />
                  ))}
                  {openingHours[1]?.map((time, index) => (
                    <TimeSlotButton
                      key={index}
                      time={time}
                      selectedTime={selectedTime}
                      onSelectTime={onSelectTime}
                      currentColor={currentColor}
                      isAvailable={time?.IsAvailable}
                    />
                  ))}
                </>
              )}
            </>
          )}
        </>
      )}
      {showError && (
        <Box sx={{ p: 1, width: '100%', mt: 1, gridColumn: '1 / -1' }}>
          <Typography
            sx={{
              textAlign: 'center',
              fontWeight: 300,
              fontSize: '12px',
            }}
          >
            <Typography
              sx={{
                textAlign: 'center',
                fontWeight: 600,
                color: currentColor.primary,
              }}
            >
              {'Restaurant closed for a private event'}
            </Typography>
            You can try selecting another date
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default TimeSlotGrid;
